import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-collapsible-card',
  imports: [MatIcon],
  templateUrl: './collapsible-card.component.html',
  styleUrl: './collapsible-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsibleCardComponent {
  protected CollapsibleCardSize = CollapsibleCardSize;

  public readonly titleText = input.required<string>();
  public readonly subtitle = input<string>();
  public readonly isInitiallyCollapsed = input<boolean>(false);
  public readonly size = input<CollapsibleCardSize>(CollapsibleCardSize.large);

  protected readonly isCollapsed = signal<boolean>(false);
  private readonly isCollapsedEffect = effect(() => {
    const isInitiallyCollapsed = this.isInitiallyCollapsed();
    this.isCollapsed.set(isInitiallyCollapsed);
  });

  protected toggleCollapsed() {
    this.isCollapsed.update(value => !value);
  }
}

export enum CollapsibleCardSize {
  small = 1,
  medium,
  large,
}
